// Login and Order Constants
export const MAIN_GREEN_COLOR = '#62B522';
export const HOVER_GREEN_COLOR = '#599402';
export const MAIN_LIGHT_GRAY_COLOR = '#ACABAC';
export const INPUT_FIELDS_BG_COLOR = '#f0f0f0';


